"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { toFilterParam } from "../const";
import removeUnwantedQueryParams from "../services/removeUnwantedQueryParams";

export default function CheckboxFilter({
  facet,
}: {
  facet: { id: string; label: string };
}) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const name = toFilterParam(`f.${facet.id}`);
  const checked = searchParams.get(name) === "true";

  function onChange() {
    const params = new URLSearchParams(searchParams);
    if (checked) params.delete(name);
    else params.set(name, "true");
    router.replace(`?${removeUnwantedQueryParams(params).toString()}`);
  }

  return (
    <label className="grid grid-cols-[auto_1fr] items-center gap-x-2 text-sm">
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        className="accent-black"
      />
      {facet.label}
    </label>
  );
}
